import type { CustomChartColor } from '@/entities/dashboards';

/** Ключ подписи цвета набора: цвет зоны назван зоной, цвет палитры долей — порядковым номером. */
export type ChartColorLabelKey =
  | 'presets.editor.colorNumber'
  | 'presets.editor.colorZoneGreen'
  | 'presets.editor.colorZoneYellow'
  | 'presets.editor.colorZoneRed';

/** Названия цветов зон в подсказках выбора: цвет зоны назван зоной, а не оттенком. */
const ZONE_COLOR_LABEL_KEY: Partial<Record<CustomChartColor, ChartColorLabelKey>> = {
  'zone-green': 'presets.editor.colorZoneGreen',
  'zone-yellow': 'presets.editor.colorZoneYellow',
  'zone-red': 'presets.editor.colorZoneRed',
};

/**
 * Ключ подписи цвета набора; номер цвета палитры подставляется отдельным доводом перевода.
 */
export const chartColorLabelKey = (color: CustomChartColor): ChartColorLabelKey =>
  ZONE_COLOR_LABEL_KEY[color] ?? 'presets.editor.colorNumber';
